import React from 'react';
import * as cls from './energy-intelligence.module.css';
import { Link } from 'react-router-dom';
import { IMG_PATH, ROUTES_PATHS } from '../../../constants';
import Meta from '../../../../components/meta';
import Hero from '../../../ui/components/hero/hero';
import { Button } from '../../../ui/components/button';
import { FAQ } from '../../../ui/layouts/faq';
import { WhyItMatters } from './why-it-matters';
import { CoreEngine } from './core-engine';
import { WhatAppliances } from './what-appliances';
import { HomeInsights } from './home-insights';
import { HowYouBenefit } from './how-you-benefit';
import { HowItWorks } from './how-it-works';
import { FooterCTAs } from './footer-ctas';

const faqs = [
  {
    question: 'What data sources do you support - smart meters or sensors?',
    answer:
      'Voltaware can work with smart-meter interval data for broad coverage, and can also use higher-frequency data sources where available. An optional sensor pathway supports ultra-high-resolution analytics when required. ',
  },
  {
    question: 'How long does integration typically take?',
    answer:
      'It depends on the chosen delivery model (API-only, dashboards, or white-label). Many teams start with a limited scope (e.g., a few key insights or segments) and expand once validated. ',
  },
  {
    question: 'What do you actually deliver - raw data or insights?',
    answer:
      'You receive structured outputs such as appliance-level usage/breakdowns, events, and higher-level indicators designed for journeys (e.g., EV charging patterns, high-bill drivers, anomaly signals), delivered via APIs and/or dashboards.',
  },
  {
    question: 'How accurate is disaggregation, and how is it measured?',
    answer:
      'Accuracy depends on data resolution, appliance mix, and region. We evaluate performance using defined methods and improve over time as models learn and optional feedback is incorporated.',
  },
  {
    question:
      'Can we use the insights for targeting EV/heat-pump programmes and tariffs?',
    answer:
      'Yes, utilities use appliance signals to segment customers, trigger journeys, and personalise offers. The exact set of segments/triggers depends on your programme goals and available data.',
  },
  {
    question: 'What about privacy and GDPR?',
    answer:
      'Voltaware follows privacy-by-design principles and supports standard utility procurement requirements (data-processing terms, security documentation, and controlled access).',
  },
  {
    question: 'Do customers need smart plugs or manual tagging?',
    answer:
      'No, Voltaware works from a single measurement point. Manual tagging is not required; optional feedback can improve precision.',
  },
  {
    question:
      'Can we embed this in our app/portal or use white-label experiences?',
    answer:
      'Both options are supported: integrate via APIs into your existing channels, or deploy a white-label web/mobile experience powered by Voltaware.',
  },
  {
    question: 'Does this reduce high - bill contacts in practice ?',
    answer:
      'That’s a common objective: clearer breakdowns and explanations can help reduce unnecessary contacts and improve trust. Impact varies by journey design and rollout approach, so we typically validate through pilots and measurement.',
  },
];

export const V2EnergyIntelligence = () => {
  return (
    <>
      <Meta
        title="Energy Intelligence through AI Disaggregation | Voltaware"
        description="Understand your home’s energy use with appliance-level insights powered by AI disaggregation. Clear bill breakdowns, intelligent energy insights, safety alerts, and smart-meter compatibility for homes and utilities."
        // image="https://voltaware.com/img/v2/our-technology/.svg"
      />

      <Hero
        className={cls.hero}
        items={[
          {
            img: `${IMG_PATH}/our-technology/energy-intelligence/ai-disaggregation-hero.png`,
            imgAlt:
              'Voltaware app showing appliance-level energy insights with floating intelligent insight cards',
            title: 'Energy Intelligence through AI Disaggregation',
            caption:
              'Turn smart-meter and sensor data into appliance-level insights - fast, continuous, and without manual tagging.',
            action: (
              <div className={cls.actions}>
                <Link to={ROUTES_PATHS.REQUEST_A_DEMO}>
                  <Button>Request Demo</Button>
                </Link>
                <Link to={ROUTES_PATHS.REQUEST_A_DEMO}>
                  <Button>Get Demo</Button>
                </Link>
              </div>
            ),
          },
        ]}
      />

      <div className={cls['energy-intelligence-page']}>
        <WhyItMatters />

        <CoreEngine />

        <WhatAppliances />

        <HomeInsights />

        <HowYouBenefit />

        <HowItWorks />

        <div className={cls.faqWrapper}>
          <FAQ customFaqs={faqs} shouldAnimate={false} />
        </div>

        <FooterCTAs />
      </div>
    </>
  );
};
